
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";
import { ResourceGrid } from "@/components/resource/ResourceGrid";
import { ResourcesEmpty } from "@/components/resource/ResourcesEmpty";

interface TraineeResourcesViewProps {
  resources: any[] | undefined;
}

export const TraineeResourcesView = ({ resources }: TraineeResourcesViewProps) => {
  return (
    <>
      <Alert className="mb-6">
        <Info className="h-4 w-4" />
        <AlertDescription>
          Training resources will appear here when they are shared with you.
        </AlertDescription>
      </Alert>
      
      {resources && resources.length > 0 ? (
        <ResourceGrid resources={resources} />
      ) : (
        <ResourcesEmpty isTrainee={true} />
      )}
    </>
  );
};
